<template>
    <div class="case-study-slider">   
        <div class="container case-study-categories__container">
            <div class="case-study-categories">
                <div v-for="(slide , slideIndex) in caseStudies" :key="'category-' + slideIndex" class="case-study__link-wrap">
                    <span class="case-study-categories__link" @click="activeSlide = slide" :class="{'active': activeSlide.title == slide.title}">{{ slide.title }}</span>
                </div>
            </div>
        </div>

        <div class="container">
            <h3 class="case-study-slider__heading">{{activeSlide.title}}</h3>
        </div>
        <div class="container">
            <div class="case-study-slider__wrapper" >
                <div v-for="(slide , slideIndex) in activeSlide.items" :key="slideIndex" class="case-study__slide" :style="`background-image:url(${slide.image})`">
                    <div class="case-study__content">{{slide.title}}</div>
                    <a v-if="slide.url" :href="slide.url"  class="case-study__link">{{slide.linkTitle}}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        // this.caseStudies = [
        //     {
        //         title: 'Reproductive Rights',
        //         items: [
        //             {
        //                 url: 'https://google.com',
        //                 title: 'O’Melveny engages in a variety of pro bono work to assist families and children facing custody disputes and economic challenges, among other hardships',
        //                 linkTitle: 'Read Full Case Study'
        //             },
        //             {
        //                 url: 'https://google.com',
        //                 title: 'Reproductive Rights 2 O’Melveny engages in a variety of pro bono work to assist',
        //                 linkTitle: 'Read Full Case Study'
        //             },
        //             {
        //                 url: 'https://google.com',
        //                 title: 'Reproductive Rights 3  families and children facing custody disputes and economic challenges, among other hardships',
        //                 linkTitle: 'Read Full Case Study'
        //             }, 
        //             {
        //                 url: 'https://google.com',
        //                 title: 'Reproductive Rights 4  families and children facing custody disputes and economic challenges, among other hardships',
        //                 linkTitle: 'Read Full Case Study'
        //             }
        //         ]
        //     },
        //     {
        //         title: 'Children & Families',
        //         items: [
        //             {
        //                 url: 'https://google.com',
        //                 title: 'Children & Families',
        //                 linkTitle: 'Read Full Case Study'
        //             },
        //             {
        //                 url: 'https://google.com',
        //                 title: 'Children & Families 2',
        //                 linkTitle: 'Read Full Case Study'
        //             },
        //             {
        //                 url: 'https://google.com',
        //                 title: 'Children & Families 3',
        //                 linkTitle: 'Read Full Case Study'
        //             },
        //             {
        //                 url: 'https://google.com',
        //                 title: 'Children & Families 4',
        //                 linkTitle: 'Read Full Case Study'
        //             },
        //             {
        //                 url: 'https://google.com',
        //                 title: 'Children & Families 5',
        //                 linkTitle: 'Read Full Case Study'
        //             }
        //         ]
        //     },
        //     {
        //         title: 'Racial Justice',
        //         items: [
        //             {
        //                 url: 'https://google.com',
        //                 title: 'Racial Justice',
        //                 linkTitle: 'Read Full Case Study'
        //             },
        //             {
        //                 url: 'https://google.com',
        //                 title: 'Racial Justice 2',
        //                 linkTitle: 'Read Full Case Study'
        //             },
        //             {
        //                 url: 'https://google.com',
        //                 title: 'Racial Justice 3',
        //                 linkTitle: 'Read Full Case Study'
        //             }
        //         ]
        //     },
        //     {
        //         title: 'Appellate',
        //         items: [
        //             {
        //                 url: 'https://google.com',
        //                 title: 'Appellate',
        //                 linkTitle: 'Read Full Case Study'
        //             },
        //             {
        //                 url: 'https://google.com',
        //                 title: 'Appellate 2',
        //                 linkTitle: 'Read Full Case Study'
        //             },
        //             {
        //                 url: 'https://google.com',
        //                 title: 'Appellate 3',
        //                 linkTitle: 'Read Full Case Study'
        //             }
        //         ]
        //     },
        //     {
        //         title: 'Appellate 2',
        //         items: [
        //             {
        //                 url: 'https://google.com',
        //                 title: 'Appellate',
        //                 linkTitle: 'Read Full Case Study'
        //             },
        //             {
        //                 url: 'https://google.com',
        //                 title: 'Appellate 2',
        //                 linkTitle: 'Read Full Case Study'
        //             },
        //             {
        //                 url: 'https://google.com',
        //                 title: 'Appellate 3',
        //                 linkTitle: 'Read Full Case Study'
        //             }
        //         ]
        //     },
        // ];
        this.activeSlide = this.caseStudies[0];
        this.$nextTick(() => {
            this.setCarouselPadding();
        });
    },
    data() {
        return {
            caseStudies: [],
            activeSlide: {},
            paddingLeft: 40
        }
    },
    methods: {
        setCarouselPadding: function() {
            this.setCarouselPaddingLeft();
            let self = this;
            window.addEventListener("resize", function () {
                self.setCarouselPaddingLeft();
            });
        },
        setCarouselPaddingLeft: function() {
            let value = document.querySelector(".header__logo-wrapper").offsetLeft;
            this.paddingLeft = value + "px";
        } 
    }
}
</script>
